var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank"},[_c('div',{staticClass:"bank-value"},[_vm._v(_vm._s(_vm.chipCount))]),_c('ChipStack',{attrs:{"totalChipCount":_vm.mockChips}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }